import { Adapter as s } from "../../../../adapter.js";
import { TicketHistoryDeliveryModel as l } from "./ticketHistoryDelivery.model.js";
class y extends s {
  adapt(i) {
    var e, t, r, a, o, d;
    return new l({
      status: i.status,
      externalId: i.external_id,
      deliveryType: i.delivery_type,
      logisticOperator: i.logistic_operator,
      timestamp: new Date(i.timestamp * 1e3),
      additionalData: {
        requests: (e = i.additional_data) == null ? void 0 : e.requests,
        eta: (t = i.additional_data) == null ? void 0 : t.eta,
        description: (r = i.additional_data) == null ? void 0 : r.description,
        distance: (a = i.additional_data) == null ? void 0 : a.distance,
        priority: (o = i.additional_data) == null ? void 0 : o.priority,
        trackingUrl: (d = i.additional_data) == null ? void 0 : d.tracking_url
      }
    });
  }
  serialize(i) {
  }
}
export {
  y as TicketHistoryDeliveryAdapter
};
//# sourceMappingURL=ticketHistoryDelivery.adapter.js.map
